import apiClient from './client';
import { Track, PaginatedResponse } from '../types';

export const tracksApi = {
  getAll: async (params?: {
    page?: number;
    limit?: number;
    search?: string;
    artistId?: string;
    albumId?: string;
    businessProfileId?: string;
    mood?: string;
    sort?: 'recent' | 'popular' | 'recentlyPlayed' | 'shuffle';
  }) => {
    const response = await apiClient.get<PaginatedResponse<Track>>('/tracks', { params });
    return response.data;
  },

  getRandom: async (params?: { businessProfileId?: string; mood?: string }) => {
    const response = await apiClient.get<Track>('/tracks/random', { params });
    return response.data;
  },

  getOne: async (id: string) => {
    const response = await apiClient.get<Track>(`/tracks/${id}`);
    return response.data;
  },

  logPlay: async (id: string) => {
    await apiClient.post(`/tracks/${id}/play`);
  },

  // Like/Unlike methods
  like: async (id: string) => {
    const response = await apiClient.post<{ liked: boolean; likesCount: number }>(`/tracks/${id}/like`);
    return response.data;
  },

  unlike: async (id: string) => {
    const response = await apiClient.delete<{ liked: boolean; likesCount: number }>(`/tracks/${id}/like`);
    return response.data;
  },

  getLiked: async (params?: { page?: number; limit?: number }) => {
    const response = await apiClient.get<PaginatedResponse<Track>>('/tracks/liked', { params });
    return response.data;
  },

  checkLiked: async (trackIds: string[]) => {
    const response = await apiClient.post<Record<string, boolean>>('/tracks/liked/check', { trackIds });
    return response.data;
  },
};
